import {gql} from "graphql-request";

export const GetParkBySlug = gql`
  query GetParkBySlug($slug:String!) {
	parkBySlug(slug: $slug) {
		id
		name
		description
		establishedDate
		parkType
		location
		bounds
		hasRestrooms
		hasParking
		hasCampgrounds
		hasPicnicAreas
		openingHours
		entryFee
		officialWebsite
		contactNumber
		parkStatus
		petsAllowed
		fireRestrictions
		huntingAllowed
		fishingAllowed
		elevation
		wildlife
		vegetationType
		seasonality
		popularity
		nearbyAttractions
		createdAt
		updatedAt
		mobileCoverage
		parkingAvailable
		prettyAddress
		linkToPdf
		peakBusynessTimeDescription
		parkingSpaces
		parkingPrice
		freeParking
		obfuscatedId
		tags
		url
	}
}`;

export const GetParkPOIs = gql`
  query GetParkPOIs($slug:String!) {
    parkBySlug(slug: $slug) {
      pois {
        id
        name
        klass
        type
        lonlat
        website
        email
        description
        photos {
          lgUrl
        }
        triggerGeospatialNotification
      }
    }
  }
`;

export const GetParkById = gql`
  query GetPark($id:ID!) {
    park(id: $id) {
      id
      slug
      name
      description
      establishedDate
      parkType
      location
      bounds
      hasRestrooms
      hasParking
      hasCampgrounds
      hasPicnicAreas
      openingHours
      entryFee
      officialWebsite
      contactNumber
      parkStatus
      petsAllowed
      fireRestrictions
      huntingAllowed
      fishingAllowed
      elevation
      wildlife
      vegetationType
      seasonality
      popularity
      nearbyAttractions
      createdAt
      updatedAt
      mobileCoverage
      parkingAvailable
      prettyAddress
      linkToPdf
      peakBusynessTimeDescription
      parkingSpaces
      parkingPrice
      freeParking
      obfuscatedId
      url
      staticMapImage {
        lgUrl
      }
      pois {
        id
        name
        klass
        type
        lonlat
        website
        email
        description
        photos {
          lgUrl
        }
        triggerGeospatialNotification
      }
      photos {
        lgUrl
      }
      trails {
        id
        name
        jumboImage {
          id
          url
          metadata
        }
        slug
        trailDistance
        totalElevation
        difficulty
        averageRating
        numberOfRatings
        durationString
        shortAddress
        staticMapImage
        durationMinutes
      }
      trailReviews {
        recording {
          id
          obfuscatedSlug
        }
        id
        userId
        trailId
        body
        rating
        createdAt
        updatedAt
        ranking
        photos {
          createdAt
          id
          url
          metadata
        }
        firebaseReviewId
        likes {
          id
          likeableType
          likeableId
          user {
            firebaseUserId
          }
        }
        user {
          firebaseUserId
          avatar {
            id
            url
            metadata
          }
          displayName
          title
          id
        }
      }
    }
  }`;
